/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Stop_ImpersonatingInputs */



/**
* | output |
* | --- |
* | "Stop impersonating" |
*
* @param {Nav_Stop_ImpersonatingInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const nav_stop_impersonating = /** @type {((inputs?: Nav_Stop_ImpersonatingInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Stop_ImpersonatingInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Stop met meekijken")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Arrêter de consulter ce compte")
	return /** @type {LocalizedString} */ ("Stop impersonating")
});